export function WeekendWarriorIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 14h28v22H10z" />
      <path d="M10 14c0-4 6-6 14-6s14 2 14 6" />
      <line x1="10" y1="22" x2="38" y2="22" />
      <line x1="10" y1="30" x2="38" y2="30" />
      <line x1="18" y1="14" x2="18" y2="36" />
      <line x1="30" y1="14" x2="30" y2="36" />
      <circle cx="14" cy="18" r="1.5" fill="currentColor" />
      <circle cx="34" cy="18" r="1.5" fill="currentColor" />
    </svg>
  );
}
